import { motion } from "framer-motion";

export default function SectionHeading({ chapter, kicker, title, description, dark = false }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="mb-12 sm:mb-16 max-w-3xl"
    >
      <div className="flex items-center gap-3 mb-4">
        <span className={`font-display text-sm font-bold tracking-widest ${dark ? "text-brand-light" : "text-brand-orange"}`}>
          {chapter}
        </span>
        <span className={`h-px w-10 ${dark ? "bg-brand-light/40" : "bg-brand-orange/40"}`} />
        <span className={`text-xs sm:text-sm font-semibold uppercase tracking-wider ${dark ? "text-brand-light" : "text-brand-orange"}`}>
          {kicker}
        </span>
      </div>
      <h2 className={`font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05] ${dark ? "text-white" : "text-slate-900"}`}>
        {title}
      </h2>
      {description && (
        <p className={`mt-5 text-base sm:text-lg leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>
          {description}
        </p>
      )}
    </motion.div>
  );
}
